import Skeleton from 'components/atomic/atoms/skeleton'

import InputGroup from '.'

export const InputGroupSkeleton = () => (
  <InputGroup.Root>
    <Skeleton css={{ width: 'fit-content' }}>
      <InputGroup.Label>Loading...</InputGroup.Label>
    </Skeleton>
    <Skeleton css={{ width: '$full', height: 44 }} />
  </InputGroup.Root>
)
